import { createContext, useContext, useState } from "react";

// Create the Context
const ToggleContext = createContext();

// Provider Component
export const ToggleProvider = ({ children }) => {
  const [isActive, setIsActive] = useState(false);

  // Function to toggle the state
  const toggleState = () => {
    setIsActive((prev) => !prev);
  };

  return (
    <ToggleContext.Provider value={{ isActive, toggleState }}>
      {children}
    </ToggleContext.Provider>
  );
};

// Custom Hook to use the Toggle Context
export const useToggle = () => {
  return useContext(ToggleContext);
};
